import { FirmwareResponse } from '../../../entities/remote-flash-v1/models';

export enum RemoteFlashActionNames {
  SET_FIRMWARE_STATUS = 'SET_FIRMWARE_STATUS',
  SET_FILE_EXISTS_IN_DB = 'SET_FILE_EXISTS_IN_DB',
  SET_HASH_EXISTS_IN_DB = 'SET_HASH_EXISTS_IN_DB',
}

export interface FirmwareStatusState {
  firmwareStatus: FirmwareResponse | undefined;
  softwareFileExistsInDb: boolean;
  hashExistsInDb: string;
}

interface SetFirmwareStatusAction {
  type: typeof RemoteFlashActionNames.SET_FIRMWARE_STATUS;
  payload: FirmwareResponse;
}

interface SetSoftwareFileExistsInDB {
  type: typeof RemoteFlashActionNames.SET_FILE_EXISTS_IN_DB;
  payload: boolean;
}

interface SetHasExistsInDB {
  type: typeof RemoteFlashActionNames.SET_HASH_EXISTS_IN_DB;
  payload: string;
}

export type RemoteFlashActionTypes = SetFirmwareStatusAction | SetSoftwareFileExistsInDB | SetHasExistsInDB;
